import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { IFormTemplateSectionManage } from "../../../_common/models/formTemplateSection";
import { PrimaryButton } from "../../../_components/button/primary.button";
import { toastr } from "../../../_components/toastr/toastr";
import { formTemplateSectionService } from "../../../_services/formTemplateSection.service";
import { getEnumDropdown } from "../../../_helpers/form.helper";
import { FormTemplateSectionTypeEnum } from "../../../_common/enum/forms/formTemplateSectionType.enum";
import { TextValidatorHcs } from "../../../_components/textValidator/textValidatorHcs";

export function FormTemplateSectionManage(params: {
    emitOnSave: () => void,
}) {

    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setLoading] = useState(false);
    let navigate = useNavigate();

    const { formTemplateId, formTemplateSectionId } = useParams<{ formTemplateId: string, formTemplateSectionId: string }>();
    const [data, setData] = useState<IFormTemplateSectionManage>({
        id: +(formTemplateSectionId || 0),
        name: "",
        sectionOrder: 0,
        formHtml: "",
        formTemplateId: +(formTemplateId || 0),
        formTemplateSectionTypeId: ""
    });

    useEffect(() => {
        if (+(formTemplateSectionId || 0) > 0) fetchData();

    }, [formTemplateSectionId]);

    function fetchData() {
        setLoading(true);
        return formTemplateSectionService
            .get(+(formTemplateSectionId || 0))
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return formTemplateSectionService
            .submit(data)
            .then(
                () => {
                    toastr.success("Created successfully");
                    params.emitOnSave();
                    navigate(-1);
                },
                (e) => {
                    console.log(e);
                    toastr.error("Please verify that the form is valid");
                }
            )
            .finally(() => setIsSaving(false));
    }

    function handleChange(event: any) {
        var _data = data;
        _data[event.target.name] = event.target.value;
        setData({ ..._data });
    };

    function onError(event: any) {
        toastr.error("Please verify that all fields are correct");
    }

    function disable() {
        setIsSaving(true);

        return formTemplateSectionService
            .disable(data.id)
            .then(
                () => {
                    toastr.success("Closed successfully");
                    params.emitOnSave();
                }
            )
            .finally(() => setIsSaving(false));
    }

    return (

        <ValidatorForm onSubmit={submit} noValidate>

            <Grid container spacing={1}>


                <Grid item xs={12}>
                    <TextValidator
                        label="Name"
                        value={data.name}
                        name="name"
                        required
                        fullWidth
                        validators={['required']}
                        errorMessages={['This field is required']}
                        onChange={handleChange}
                        variant="filled" />
                </Grid>

                <Grid item xs={12}>
                    <TextValidator
                        label="Section Order"
                        value={data.sectionOrder}
                        name="sectionOrder"
                        required
                        fullWidth
                        validators={['required', 'minNumber:0', 'maxNumber:15']}
                        errorMessages={['This field is required', "Section order must be between 1 and 15", "Section order must be between 1 and 15"]}
                        onChange={handleChange}
                        min={1}
                        max={10}
                        step={1}
                        variant="filled"
                        type="number" />
                </Grid>

                <Grid item xs={12}>
                    {getEnumDropdown("Section Type", "formTemplateSectionTypeId", FormTemplateSectionTypeEnum, data["formTemplateSectionTypeId"], handleChange, false)}
                </Grid>

                {data.formTemplateSectionTypeId == FormTemplateSectionTypeEnum.Questionnaire &&
                    <Grid item xs={12}>
                        <TextValidatorHcs
                            label="Number Of Questionnaire Questions To Show"
                            value={data.questionsToShowNumber}
                            name="questionsToShowNumber"
                            required
                            type="number"
                            min="0"
                            max="100"
                            fullWidth
                            variant="filled"
                            validators={['required', 'minNumber:1', 'maxNumber:100']}
                            errorMessages={['This field is required', 'Cannot be less than 1', 'Cannot be more than 100']}
                            onChange={handleChange}
                        />
                    </Grid>
                }

                <Grid item xs={6}>
                    <PrimaryButton isLoading={isLoading} isSaving={isSaving} type="submit" variant="save">Save</PrimaryButton>
                </Grid>

                {(data.formTemplateId > 0) &&
                    <Grid item xs={6}>
                        <PrimaryButton isSaving={isSaving} isLoading={isLoading} onClick={() => { navigate(-1) }} type="button" variant="remove">Back</PrimaryButton>
                    </Grid>
                }

            </Grid>
        </ValidatorForm >
    );
}